import React, { Fragment, useEffect, useRef, useState } from "react";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import { fancyTimeFormat, renderPrice } from "../../../Common/Function";
import Loading from "../../../Common/Components/Loading";
import {
  FormSubmit,
  GetData,
  GetRequest,
  SubmitCode,
} from "./Components/Services";
import BoxShadow from "../../../Common/Components/BoxShadow";
import { MenuItem, Select, TextField } from "@mui/material";
import { removeSepMoney, sepMoney } from "../../../../Web/Common/Function";
import { toast } from "react-hot-toast";
import { CgDanger } from "react-icons/cg";

function Create({ role, closeModal }) {
  const initalState = {
    loading: false,
    amount: "",
    modal: false,
    wallet: null,
    bankNumber: null,
    bankName: null
  };
  const isUser = role || JSON.parse(localStorage.getItem('user_type')) == "user" ? true : false;
  const user = JSON.parse(localStorage.getItem('user'));

  const [table, settable] = useState({
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
  });

  const amountRef = useRef();
  const [bankName, setBankName] = useState("");

  const [state, setstate] = useState(initalState);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getDataHandler();
    HandlerRequest();
  }, []);
  const HandlerRequest = data => {
    settable({ loading: true });
    GetRequest(isUser).then(data => {
      settable({ ...table, data: data, loading: false, modal: true });
    });
  };
  const Handler = data => {
    if (!data.amount || data.amount == "0") {
      toast.error("لطفا مبلغ را صحیح وارد نمائید");
      return
    }
    if (!data.bankNumber || data.bankNumber == "" || data.bankNumber.length != 24) {
      toast.error("لطفا شماره شبا را صحیح وارد نمائید");
      return
    }
    if (isUser) {
      // closeModal();
      data.user_id = user.id;
    }

    setLoading(true);
    FormSubmit(data, isUser).then(data => {
      if (!data.status) {
        setstate({
          loading: false,
          ...state,
          modal: true,
        });
      } else {
        setstate({
          loading: false,
          ...state,
          amount: "",
        });
      }
      setLoading(false);
    });
  };
  const getDataHandler = () => {
    setstate({ ...state, loading: true });
    GetData().then(result => {
      setstate({
        loading: false,
        wallet: result && result.Walletbalance,
        modal: false,
      });
      // if (isUser) {
      //   closeModal();
      // }
    });
  };
  return (
    <div className={window.screen.width > 425 && "px-4"}>
      {state.loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <>
          {!isUser
            ? <MainBody isUser={isUser} table={table} state={state} setstate={setstate} Handler={Handler}
              bankName={bankName} setBankName={setBankName} amountRef={amountRef} loading={loading} />
            :
            <>
              {state.modal
                ? <FormCheck set={setstate} state={state} isUser={isUser} closeModal={closeModal} />
                : <MainBody isUser={isUser} table={table} state={state} setstate={setstate} Handler={Handler}
                  bankName={bankName} setBankName={setBankName} amountRef={amountRef} loading={loading} closeModal={closeModal} />
              }
            </>
          }
        </>
      )}
    </div>
  );
}
const MainBody = ({ isUser, table, state, setstate, Handler, bankName, setBankName, amountRef, loading, closeModal }) => {
  const [shabaName, setShabaName] = useState("");

  const getShabaName = (shaba) => {
    let shabaSplit = shaba.slice(2, 5)
    switch (shabaSplit) {
      case "012":
        return "ملت";
      case "017":
        return "ملی";
      case "019":
        return "صادرات";
      case "015":
        return "سپه";
      case "018":
        return "تجارت";
      case "016":
        return "کشاورزی";
      case "014":
        return "مسکن";
      case "21":
        return "پست بانک";
      case "020":
        return "توسعه صادرات";
      case "057":
        return "پاسارگاد";
      case "054":
        return "پارسیان";
      case "055":
        return "اقتصاد نوین";
      case "013":
        return "رفاه";
      case "061":
        return "شهر";
      case "051":
        return "توسعه تعاون";
      case "058":
        return "سامان";
      case "59":
        return "سینا";
      case "011":
        return "صنعت و معدن";
      case "053":
        return "کار آفرین";
      default: {
        return ""
      }

    }
  }

  return (
    <Fragment>
      <div className="">
        <div className="row justify-content-center">
          <div style={{ padding: "0 15px" }}>
            <BoxShadow style={isUser && { boxShadow: "none", padding: "none" }}>
              {!isUser && <h3 className="mb-3"
                style={{
                  textAlign: "center",
                  fontSize: "17px",
                  fontWeight: "500",
                }}>
                درخواست برداشت درآمد
              </h3>
              }
              <div className="text-center">

                <div className={"mt-3 " + (isUser && "mb-3")}>
                  <small style={{ fontSize: "15px" }} >
                    {`میزان
                    ${isUser ? "وجه" : "درآمد"}
                     قابل برداشت شما   :  ${renderPrice(
                      table && table.data && table.data.amount
                    )}`}
                  </small>
                </div>

                {!isUser &&
                  <div>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "11px",
                        fontWeight: "400",
                      }}
                    >
                      حداقل میزان برداشت 100 هزار تومان می باشد
                    </p>
                  </div>
                }
                <div className="position-relative">
                  <TextField
                    fullWidth
                    type="text"
                    label={"مبلغ درخواست"}
                    size="small"
                    onChange={({ target: { value } }) => {
                      setstate({ ...state, amount: removeSepMoney(value) });
                    }}
                    min="0"
                    value={sepMoney(state.amount)}
                    inputRef={amountRef}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <span style={{
                    display: "flex", position: "absolute", left: "88px",
                    height: "32px", width: "2px", top: "4px", background: "gray",
                  }}></span>
                  <button className="btn btn-primary"
                    style={{ position: "absolute", left: "5px", top: "5px", padding: "2px 5px" }}
                    onClick={() => {
                      amountRef.current.focus();
                      setstate({ ...state, amount: table && table.data && table.data.amount })
                    }}>
                    کل موجودی
                  </button>
                </div>

                <small className="d-flex pr-2 pt-1 ">لطفا مبلغ را برحسب تومان وارد کنید</small>

                <div className="position-relative mt-4 pl4input" dir="ltr">
                  <TextField
                    fullWidth
                    type="text"
                    label={"شماره شبا"}
                    size="small"
                    onChange={({ target: { value } }) => {
                      setShabaName(getShabaName(value));
                      setstate({ ...state, bankNumber: value, bankName: getShabaName(value) });
                    }}
                    min="0"
                    value={state.bankNumber}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <span style={{
                    position: "absolute", left: "5px", top: "8px"
                  }}>IR -</span>

                  <span style={{
                    position: "absolute", right: isUser ? "10px" : "95px", top: "8px"
                  }}>{shabaName}</span>

                  {!isUser &&
                    <>
                      <span style={{
                        display: "flex", position: "absolute", right: "88px",
                        height: "32px", width: "2px", top: "4px", background: "gray",
                      }}></span>

                      <Select
                        className="noneBorder"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={bankName}
                        label="Age"
                        onChange={(e) => {
                          setBankName(e.target.value);
                          setstate({ ...state, bankNumber: e.target.value });
                        }}
                        style={{
                          position: "absolute", right: "4px",
                          height: "32px", width: "80px", top: "4px", background: "white"
                        }}
                      >
                        {
                          table.data?.bankNumbers ? table.data.bankNumbers.map(item => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))
                            : <MenuItem value={"صبر کنید"}>صبر کنید</MenuItem>
                        }
                      </Select>
                    </>}

                </div>

              </div>
              <div className="row justify-content-center mt-4">
                <p className="col-12">
                  <CgDanger size={20} className="ml-1 text-danger" />
                  وجه درخواستی  شما حداکثر تا  36 ساعت آینده به حساب شما واریز خواهد شد
                </p>
                <button
                  className="btn btn-primary"
                  disabled={loading}
                  onClick={() => {
                    if (state.amount !== "") {
                      Handler({ amount: state.amount, bankNumber: state.bankNumber, bankName: state.bankName });
                    }
                  }}
                >
                  {loading ? "در حال بررسی " : "ارسال درخواست"}
                </button>
              </div>
            </BoxShadow>
          </div>
        </div>
      </div>

      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ارسال کد تایید"}
      >
        <FormCheck set={setstate} state={state} isUser={isUser} closeModal={closeModal} />
      </CustomModal>
    </Fragment>
  )
}

const FormCheck = ({ set, state, isUser, closeModal }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [timecode, setTimecode] = useState(120);
  const [code, setcode] = useState("");
  const SetTimeOut = () => {
    setTimeout(() => {
      if (timecode >= 1) {
        setTimecode(timecode - 1);
      }
    }, 1000);
  };
  SetTimeOut();
  const [loading, setLoading] = useState(false);
  const submitCodeHandler = data => {
    setLoading(true);
    if (isUser) {
      // closeModal();
      data.user_id = user.id;
    }
    SubmitCode(data, isUser).then(() => {
      set({ ...state, modal: false });
      setLoading(false);
      if (isUser) {
        closeModal();
      }
    });
  };
  return (
    <div>
      <div>
        <div>
          <span>زمان باقی مانده : </span>
          <span>{fancyTimeFormat(timecode)}</span>
        </div>
        <div>
          <input
            type="number"
            className="form-control mt-2 "
            placeholder="کد تایید را وارد کنید"
            onChange={e => setcode(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-primary mt-2"
            onClick={() => {
              submitCodeHandler({ code });
            }} >
            {loading ? "در حال بررسی " : "   ارسال کد"}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Create;
